import { Reducer } from 'redux';
import {
  ADD_ONE_WAY_FEE,
  ADD_ONE_WAY_FEES,
  LIST_ALL_ONE_WAY_FEES,
  OneWayFeeActionTypes,
  OneWayFeesState
} from '../types/onewayfees.types';

const initialState: OneWayFeesState = {
  oneWayFees: [],
  oneWayFee: null,
  lastFetch: null
};

export const oneWayFeeReducer: Reducer<OneWayFeesState> = (
  state: OneWayFeesState = initialState, action
) => {
  const timeOfAction = new Date().getTime();
  switch ((action as OneWayFeeActionTypes).type) {
    case LIST_ALL_ONE_WAY_FEES:
      return {
        ...state,
        oneWayFees: action.payload.oneWayFees,
        lastFetch: timeOfAction
      };
    case ADD_ONE_WAY_FEES:
      return {
        ...state,
        oneWayFees: action.payload.oneWayFees,
        lastFetch: timeOfAction
      };
    case ADD_ONE_WAY_FEE:
      return {
        ...state,
        oneWayFee: action.payload.oneWayFee,
        lastFetch: timeOfAction
      };
    default:
      return state;
  }
};
